<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.7.985h-2.953V0H3.937v.985H.985A.93.93 0 0 0 0 1.968V4.33a4.462 4.462 0 0 0 3.937 4.43v.098a5.923 5.923 0 0 0 4.626 5.807l-.692 2.067H5.608a.944.944 0 0 0-.886.692l-.788 2.263h11.81l-.787-2.263a.945.945 0 0 0-.886-.692h-2.263l-.693-2.067a5.923 5.923 0 0 0 4.627-5.807v-.099a4.462 4.462 0 0 0 3.936-4.429V1.968A.93.93 0 0 0 18.7.985zM3.937 6.792A2.628 2.628 0 0 1 1.968 4.33V2.952h1.969v3.84zm7.874 3.05L9.842 8.76 7.874 9.842l.493-1.968L6.89 5.905h2.067l.886-1.968.886 1.968h2.067L11.32 7.874l.492 1.968zm5.905-5.512a2.538 2.538 0 0 1-1.968 2.462V2.953h1.968V4.33z" fill="#1D1D1D" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconCompetitions',
};
</script>
